import { createStore } from 'vuex'

export default createStore({
  state: {
      userInfo:JSON.parse(localStorage.getItem("userInfo")) || {}
  },
  getters: {
  },
  mutations: {
      setInfo(state,data){
        localStorage.setItem('userInfo',JSON.stringify(data))
        state.userInfo = data
      }
  },
  actions: {
  },
  modules: {
  }
})
